import api from './api';
import { ApiResponse } from '../types';

interface UserRegistrationData {
  role: 'user';
  profilePicUrl?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  about?: string;
}

interface UserRegistrationResponse {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  profilePicUrl?: string;
  phoneNumber: string;
  about?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ApiUser {
  _id: string;
  firstName: string;
  lastName: string;
  companyName?: string;
  country: string;
  gender: string;
  email: string;
  phoneNumber: string;
  profilePicUrl?: string;
  documents: string[];
  active: boolean;
  role: 'user' | 'partner' | 'admin';
  partnerType?: 'serviceProvider' | 'accommodationProvider' | 'transportProvider';
  verified: boolean;
  about?: string;
  emailVerificationOTPExpires?: string;
  emailVerificationAttempts: number;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface GetAllUsersResponse {
  statusCode: number;
  message: string;
  data: ApiUser[];
  pagination: PaginationInfo;
}

export interface GetAllUsersParams {
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  search?: string;
  role?: string;
  status?: string;
}

export const userService = {
  async registerUser(userData: UserRegistrationData): Promise<ApiResponse<UserRegistrationResponse>> {
    const response = await api.post('/user/register', userData);
    return response.data;
  },

  async getAllUsers(params: GetAllUsersParams = {}): Promise<GetAllUsersResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.order) queryParams.append('order', params.order);
    if (params.search) queryParams.append('search', params.search);
    if (params.role) queryParams.append('role', params.role);
    if (params.status) queryParams.append('status', params.status);

    const response = await api.get(`/user/all?${queryParams.toString()}`);
    const responseData = response.data;
    
    console.log('Raw API response:', responseData);
    console.log('responseData.data:', responseData.data);
    
    // Handle the nested data structure from the API
    // The API returns: { statusCode, message, data: { data: [...], pagination: {...} } }
    return {
      statusCode: responseData.statusCode,
      message: responseData.message,
      data: responseData.data?.data || [],
      pagination: responseData.data?.pagination || {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
      }
    };
  }
};
